import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_account_entitlement_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  topup_amount:fromDatatype.IntegerDatatypeInterface;
  no_limit: boolean;
  topup_recurring_period_in_days: fromDatatype.IntegerDatatypeInterface;
  topup_recurring_period_in_months: fromDatatype.IntegerDatatypeInterface;
  validity_period_in_days: fromDatatype.IntegerDatatypeInterface;
  validity_period_in_months: fromDatatype.IntegerDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  validity_period_in_years: fromDatatype.IntegerDatatypeInterface;
  topup_recurring_period_in_years: fromDatatype.IntegerDatatypeInterface;
  calculation_logic: fromDatatype.VarcharDatatypeInterface;
  is_prorated_for_new_employees: boolean;
  prorated_yearly_end_date: fromDatatype.TimestampTzDatatypeInterface;
  prorated_yearly_amount: fromDatatype.NumericDatatypeInterface;
}

export class bl_aat_claim_account_entitlement_hdr_RowClass implements bl_aat_claim_account_entitlement_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  topup_amount:fromDatatype.IntegerDatatypeInterface;
  no_limit: boolean;
  topup_recurring_period_in_days: fromDatatype.IntegerDatatypeInterface;
  topup_recurring_period_in_months: fromDatatype.IntegerDatatypeInterface;
  validity_period_in_days: fromDatatype.IntegerDatatypeInterface;
  validity_period_in_months: fromDatatype.IntegerDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  validity_period_in_years: fromDatatype.IntegerDatatypeInterface;
  topup_recurring_period_in_years: fromDatatype.IntegerDatatypeInterface;
  calculation_logic: fromDatatype.VarcharDatatypeInterface;
  is_prorated_for_new_employees: boolean;
  prorated_yearly_end_date: fromDatatype.TimestampTzDatatypeInterface;
  prorated_yearly_amount: fromDatatype.NumericDatatypeInterface;
}
